import React from 'react'
import CountdownTimer from './CountdownTimer'
import EventsSection from './EventsSection'
import IEEE2022 from './IEEE2022'
const Home = () => {
  const pastEvents = [
    {
      title: 'Code Spark',
      description:
        'Competitive coding is a brain sport where participants compete with each other and against time to get a solution as optimal as possible. Welcome to the Code Spark event for Novice as well as Experts Divisions',
      fee: 'IEEE: Rs.30 | non-IEEE: Rs.40',
      languages: 'C | C++ | Java | Python | C#',
      participationType: 'Individual',
      maxTeamSize: '1',
      timeOut: 1696294800,
      dateTime: "3rd Oct'23 7:00PM IST"
    }
  ]
  const upcomingEvents = [
    {
      title: 'IDEA IGNITERS',
      description: "IDEA IGNITERS: A two-round competition challenging participants to pitch innovative startup ideas and showcase their brilliance.",
      fee: 'IEEE: Rs.40 | non-IEEE: Rs.50',
      participationType: 'Team',
      maxTeamSize: '3',timeOut: 1697437800,
      register: 'https://forms.gle/Qd9kokFAPuWY2Qa89',
      dateTime: "17th Oct'23 9:40AM IST"

    },
    {
      title: 'MAGICAL HUNT',
      description: "MAGICAL HUNT: A multi-round adventure featuring message decoding, riddles, treasure hunting, audio challenges, and a thrilling surprise round.",
      fee: 'IEEE: Rs.40 | non-IEEE: Rs.50',
      participationType: 'Team',
      maxTeamSize: '3',
      timeOut: 1697437800,
      register: 'https://forms.gle/Qd9kokFAPuWY2Qa89',
      dateTime: "17th Oct'23 9:40AM IST"
    },
    {
      title: 'BRAWN v/s BRANIACS',
      description: "Brawn vs. Brains is a thrilling competition featuring three rounds, including a quick-witted quiz, geographical puzzles, and a test of extreme endurance.",
      fee: 'IEEE: Rs.40 | non-IEEE: Rs.50',
      participationType: 'Team',
      maxTeamSize: '3',timeOut: 1697437800,
      register: 'https://forms.gle/Qd9kokFAPuWY2Qa89',
      dateTime: "17th Oct'23 9:40AM IST"
    }
  ]
  return (
    <div>
      <p style={{fontSize: "40px",fontWeight: "500", textAlign: "center",marginTop: "20px"}}>DAYS TO GO</p>
      <CountdownTimer/>
      <hr style={{width: "70%"}}/>
      <EventsSection events={upcomingEvents} tense={"Upcoming"}/>
      <hr style={{width: "70%"}}/>
      <EventsSection events={pastEvents} tense={"Past"}/>
      <hr style={{width: "70%"}}/>
      <IEEE2022/>

    </div>
  )
}

export default Home
